const emotionCacheProps = {
  key: "mui",
  prepend: true
};

export default emotionCacheProps;
